import React, { useState } from "react";
import { useDispatch } from "react-redux";
import hamburger from "../../../Assets/hamburger.svg";
import { navbarToggle } from "../../../redux/actions/student";
import Navlinks from "../Navlinks/Navlinks";
import style from "./Hambergur..module.css";
const Hamburger = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handle = () => {
    setOpen(!open);
  };
  return (
    <div
      className={style.hamburder}
      onClick={() => {
        setOpen(!open);
        dispatch(navbarToggle(!open));
      }}
    >
      <img src={hamburger} alt="" />
      {open && <Navlinks handle={handle} />}
    </div>
  );
};

export default Hamburger;
